import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconHomeSearch, IconSearchPdfCard} from "../../Icon";
import {t} from "i18next";
import {ConfigProvider, Input, Modal} from "antd";
import {
    base64ToBlob,
    firstLetterUpper,
    generateRandomPageKey, generateUUID2, getFileNameWithoutExt,
    getImagePathWithTheme, getPdfImageThumb,
    imgPathPerfix,
    isDarkMode,
    isNoteElement,
    isPdfFileElement,
    isStringNullOrEmpty
} from "@/utils";
import {
    DEFAULT_NOTE_HEIGHT,
    DEFAULT_NOTE_WIDTH,
    EVENT_CHOOSE_INSERT_PDF_FILE, EVENT_REFRESH_LIBRARY_LIST,
    FROM_ADD,
    FROM_HOME_LIBRARY, MAX_Z_INDEX, MEDIIUM_Z_INDEX
} from "@/Const";
import {openEditor} from "@/state";
import Global from "@/global";
import {postMessage} from "@/common/event";
import {getAllMindmapPdfFiles} from "../../../@excalidraw/packages/excalidraw/element/mindMap";
import PageLibrary from "@/views/Library/PageLibrary";
import {updateCard} from "@model/card";
import {ipcInvoke} from "@/common/ipc";
import {MIME_TYPES} from "../../../@excalidraw/packages/excalidraw";
import {resizeImageFile} from "../../../@excalidraw/packages/excalidraw/data/blob";
import {fileToBase64} from "@/components/EditorV2/ImagePaste";
import global from "@/global";

let mArrayAllDatas:any = [];

const DialogChooseCardPdf = forwardRef((props:{onOkEvent:any,onCloseEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const fileInputRef = useRef(null);

    const onShowDialog = (elements:any,type:string|'pdf'|'card')=>{
        setIsShowDialog(true);
        setChooseType(type);
        mArrayAllDatas.length = 0;

        // postMessage(EVENT_REFRESH_LIBRARY_LIST);
        // setIsInitLibrary(true);

        if (window.onGetProjectData){
            window.onGetProjectData().then(res=>{
                var arrayNewDatas:any = [];
                if (type == 'pdf'){
                    for (let i=0;i<res.canvas.length;i++){
                        const canvas = res.canvas[i];
                        for (let j=0;j<canvas.drawJson.elements.length;j++){
                            const element = canvas.drawJson.elements[j];
                            if (isPdfFileElement(element)){
                                var itemPdf = {
                                    id:element.id,
                                    type:type,
                                    fileName:element.customData.generationData.fileName,
                                    showName:element.customData.generationData.showName
                                }
                                arrayNewDatas.push(itemPdf);
                            }
                        }
                    }
                    //所有mindmap中的pdf file
                    arrayNewDatas.push(...getAllMindmapPdfFiles());
                }else if (type == 'card'){
                    for (let i=0;i<res.notes.length;i++){
                        const note = res.notes[i];
                        let width = DEFAULT_NOTE_WIDTH;
                        let height = DEFAULT_NOTE_HEIGHT;
                        var itemCard = {
                            id:note.key,
                            type:type,
                            showName:note.title,
                            content:note.noteDataDoc,
                            width,
                            height
                        }
                        arrayNewDatas.push(itemCard);
                    }
                }
                mArrayAllDatas.push(...arrayNewDatas);
                setArrayDatas(arrayNewDatas);
            })
        }
    }

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [chooseType,setChooseType] = useState('');
    const [searchKey,setSearchKey] = useState('');
    const [arrayDatas,setArrayDatas] = useState([]);
    const [isInitLibrary,setIsInitLibrary] = useState(false);

    useEffect(()=>{
        global.g_isDialogLink = true;
        global.g_showDialogs['dialogLink'] = true;
        return ()=>{
            global.g_isDialogLink = false;
            global.g_showDialogs['dialogLink'] = false;
        }
    },[])
    /**
     * 添加
     */
    const onAddClick = ()=>{
        if (chooseType == 'card') {
            // Global.g_currentNoteData = {id:generateRandomPageKey()}
            // openEditor(Global.g_currentNoteData.id,true,false);
            // window.eventAddChooseCard=(note:any)=> {
            //     // var arrayNew = [...arrayDatas];
            //     var item = {
            //         id:note.id,
            //         type:chooseType,
            //         name:note.name,
            //         doc:note.doc,
            //     }

            // }
            const data = {
                id:generateUUID2(),
                doc:'',
                isDeleted:0,
                name:'',
                type:'card',
                thumbHtml:'',
                createTime:Date.now()
            }
            //直接插入并关闭
            setIsShowDialog(false);
            updateCard(data).then(res=>{
                setTimeout(()=>{
                    props.onOkEvent(data);
                },10)
            })
        }else if (chooseType == 'pdf') {
            // postMessage(EVENT_CHOOSE_INSERT_PDF_FILE);
            // window.eventAddChoosePdf = (item:any)=> {
            //     //直接插入这个并关闭
            //     setIsShowDialog(false);
            //     setTimeout(()=>{
            //         props.onOkEvent(item);
            //     },10)
            // }

            fileInputRef.current?.click();

        }else if (chooseType == 'image'){
            //添加到library
            var item = {
                item:generateUUID2(),
                type:chooseType,
                // fileName:
            }
        }
    }

    function getTitle(){
        if (chooseType == 'card'){
            return t("Card");
        }else if (chooseType == 'pdf'){
            return "PDF";
        }else if (chooseType == 'image'){
            return t("Image");
        }
        return firstLetterUpper(chooseType);
    }

    async function resizeBase64ImageSize(szImgBase64: any) {
        try {
            let file = new File([base64ToBlob(szImgBase64)], 'preview', {type: MIME_TYPES.png});
            const newImageFile = await resizeImageFile(file,
                {
                    outputType: MIME_TYPES.jpg,
                    maxWidthOrHeight: 600,
                });
            szImgBase64 = await fileToBase64(newImageFile);
        } catch (e) {
            console.log('thumb resize err...' + e);
        }
        return szImgBase64;
    }

    const handleFileChange = (event: any) => {
        const selectedFile = event.target.files[0];
        ipcInvoke('copy-file', {filePath: selectedFile.path}).then(async (res) => {
            let szImgBase64 = await getPdfImageThumb('localfile://' + res);
            let szId = crypto.randomUUID();
            // szImgBase64 = await resizeBase64ImageSize(szImgBase64);
            await ipcInvoke('write-base64-image',{imgBase64:szImgBase64,fileName:szId+".png"});
            var item = {
                id: szId,
                type: 'pdf',
                fileName: res,
                name: getFileNameWithoutExt(res),
                isSingle: true,
                thumbImage: "localfile://"+szId+".png"
            }
            //保存到card
            await updateCard(item);
            props.onOkEvent(item);
            if (props.onCloseEvent){
                props.onCloseEvent()
            }
        });
    }

    return(
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        /* 这里是你的组件 token */
                        contentBg:'var(--home-left-background-color)',
                    },
                },
            }}>
            <Modal zIndex={MEDIIUM_Z_INDEX} width={958} bodyStyle={{height:'670px',margin:'-20px -24px -26px -24px',padding:'20px 0',background:'var(--home-left-background-color)'}}
                   open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={''} afterOpenChange={(e)=>{
                       if (!e) {
                           if (props.onCloseEvent){
                               props.onCloseEvent()
                           }
                       }
            }} onCancel={()=> {
                setIsShowDialog(false)
            }}>
                <div style={{height:'calc(100% - 30px)',background:'var(--home-left-background-color)'}}>
                    <span className={'dialog-title ml-6'} style={{marginLeft:'20px'}}>{getTitle()}</span>
                    <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
                    <div className={'hovered flex-center'} style={{position: "absolute", right: '16px', top: '17px',width:'26px',height:'26px',borderRadius:'15px',display:'none'}} onClick={() => {
                        onAddClick();
                    }}>
                        <img className={'img-16'} src={getImagePathWithTheme('add_black_1')} />
                    </div>

                    {
                        <PageLibrary from={FROM_ADD} type={chooseType} szContainerId={generateUUID2()} source={'dialogLink'} isInsertNewLibrary={chooseType == 'webLink'?false:true} onItemSelectedCallback={(item:any)=>{
                            if (item.type == 'add') {
                                //添加
                                onAddClick();
                            }else {
                                props.onOkEvent(item);
                                setIsShowDialog(false);
                            }
                        }}/>
                    }



                    {
                        //旧的添加方式。
                        // <>
                        //     <Input prefix={<IconSearchPdfCard/>}
                        //            suffix={<img className='img-mini-small-8 cursor-pointer'
                        //                         style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                        //                         onClick={() => {
                        //                             setSearchKey('');
                        //                             setArrayDatas(mArrayAllDatas);
                        //                         }}
                        //                         src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                        //            variant={"borderless"}
                        //            className={'input-border input-card-placeholder'}
                        //            style={{width: '100%', height: '32px'}}
                        //            placeholder={t("Search")} value={searchKey} onChange={(event)=>{
                        //         setSearchKey(event.currentTarget.value);
                        //         var arrayNewData = mArrayAllDatas.filter(p=>p.showName.indexOf(event.currentTarget.value) >= 0);
                        //         setArrayDatas(arrayNewData);
                        //     }}/>
                        //     <span className={'mt-12'}
                        //           style={{color: 'var(--text-color-bab8b8)',display:'block'}}>{(chooseType == 'card' ? t("Cards") : t("PDFs")) + " " + t("InThisProject")}</span>
                        //     <div className={'flex-col mt-6'}>
                        //         {
                        //             arrayDatas.map(p => (
                        //                 <div onClick={()=>{
                        //                     props.onOkEvent(p);
                        //                     setIsShowDialog(false);
                        //                 }} style={{height:'32px',margin:'0 -16px',padding:'0 16px'}} className={'flex-row-vertical-center hovered-gray'}>
                        //                     <img className={'img-16'} src={getImagePathWithTheme(chooseType == 'card'?'choose_card_card':'choose_card_pdf')}/>
                        //                     <span className={'ml-10 span-single-line'}>{p.showName}</span>
                        //                 </div>
                        //             ))
                        //         }
                        //     </div>
                        // </>
                    }

                    {/*隐藏的文件选择*/}
                    <div className="file-selector">
                        <input
                            ref={fileInputRef}
                            type="file"
                            id="file-input-0"
                            accept=".pdf"
                            style={{display: 'none'}}
                            onChange={handleFileChange}
                        />
                    </div>


                </div>
            </Modal>

        </ConfigProvider>

)
})

export default DialogChooseCardPdf;